import React from "react";

import studens01Img from "../img/students/img1.svg"
import studens02Img from "../img/students/img2.svg"
import studens03Img from "../img/students/img3.svg"
import studens04Img from "../img/students/img4.svg"

import ovLine1 from "../img/overlays/prog-ov-line-1.svg"
import ovImg1 from "../img/overlays/prog-ov-1.svg"
import ovImg2 from "../img/overlays/prog-ov-2.svg"

import ovImg3 from "../img/overlays/prog-ov-3.svg"
import ovImg4 from "../img/overlays/prog-ov-4.svg"
import ovImg5 from "../img/overlays/prog-ov-5.svg"
import ovImg6 from "../img/overlays/prog-ov-6.svg"
import ovImg7 from "../img/overlays/prog-ov-7.svg"

import ovImg8 from "../img/overlays/prog-ov-8.svg"
import ovImg9 from "../img/overlays/prog-ov-9.svg"
import ovImg10 from "../img/overlays/prog-ov-10.svg"
import ovImg11 from "../img/overlays/prog-ov-11.svg"
import ovImg12 from "../img/overlays/prog-ov-12.svg"
import ovImg13 from "../img/overlays/prog-ov-13.svg"

import ovImg14 from "../img/overlays/prog-ov-14.svg"
import ovLine2 from "../img/overlays/prog-ov-line-2.svg"
import ovLine3 from "../img/overlays/prog-ov-line-3.svg"
import ovImg15 from "../img/overlays/prog-ov-15.svg"
import ovImg16 from "../img/overlays/prog-ov-16.svg"

import ovImg17 from "../img/overlays/prog-ov-17.svg"
import ovImg18 from "../img/overlays/prog-ov-18.svg"
import ovImg19 from "../img/overlays/prog-ov-19.svg"

import "../style/programas.css"

function Programas() {
    return (
        <div className="programas-container">
            <div className="main thin-wrapper">
                <b>Nossos Programas</b>
                <span>A HUG desenvolve programas educacionais baseados na mesma metodologia, <br />adaptados às diferentes realidades e necessidades das comunidades escolares.</span>
                <img src={ovLine1} alt="" className="ov line-top" />
                <img src={ovImg1} alt="" className="ov ov1" />
                <img src={ovImg2} alt="" className="ov ov2" />
            </div>

            <div className="socioemocional thin-wrapper">
                <div>
                    <b>Programa HUG – Educação Socioemocional para Escolas</b>
                    <span>Programa estruturado com material pedagógico alinhado à BNCC, formação contínua de educadores, acompanhamento <br />pedagógico, avaliação de resultados e suporte digital por meio da Plataforma PAX.</span>
                    <a href="#">
                        <svg width="350" viewBox="0 0 380 50" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                            <path d="M366.129 44.8643C248.752 50.4415 131.072 50.4415 13.6955 44.8643C8.2104 44.5908 2.41106 40.952 1.44185 36.8256C-0.480615 28.5688 -0.480615 20.4785 1.44185 12.2217C2.41106 8.09526 8.2104 4.46037 13.6955 4.1829C131.072 -1.3943 248.752 -1.3943 366.129 4.1829C371.614 4.45641 377.413 8.09526 378.383 12.2217C380.305 20.4785 380.305 28.5688 378.383 36.8256C377.413 40.952 371.614 44.5869 366.129 44.8643Z" fill="#FF6C02"/>
                        </svg>

                        <span>Conheça o Programa para Escolas</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="17" viewBox="0 0 25 17" fill="none" className="arrow">
                            <path d="M15.2134 15.9338C14.731 15.4515 14.731 14.6722 15.2134 14.1899L20 9.37848H1.23686C0.556585 9.37848 -1.90735e-06 8.8219 -1.90735e-06 8.14162C-1.90735e-06 7.46135 0.556585 6.90477 1.23686 6.90477H20L15.201 2.10575C14.7186 1.62338 14.7186 0.844156 15.201 0.361781C15.6834 -0.120594 16.4626 -0.120594 16.945 0.361781L23.8714 7.27582C24.3537 7.7582 24.3537 8.53742 23.8714 9.01979L16.9573 15.9338C16.475 16.4038 15.6834 16.4038 15.2134 15.9338Z" fill="white"/>
                        </svg>
                    </a>
                </div>
                <img src={ovImg3} alt="" className="ov ov3" />
                <img src={ovImg4} alt="" className="ov ov4" />
                <img src={ovImg5} alt="" className="ov ov5" />
                <img src={ovImg6} alt="" className="ov ov6" />
                <img src={ovImg7} alt="" className="ov ov7" />
            </div>

            <div className="vivencias thin-wrapper">
                <div>
                    <b>Programa HUG – Vivências Socioemocionais</b>
                    <span>Ações, oficinas e projetos que promovem sensibilização, diálogo, práticas restaurativas e fortalecimento da convivência, <br />envolvendo estudantes, educadores, famílias e comunidade escolar.</span>
                    <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="380" viewBox="0 0 413 49" fill="none" className="bg">
                            <path d="M397.987 44.5876C270.397 50.1303 142.477 50.1303 14.8872 44.5876C8.92481 44.3157 2.62086 40.6993 1.5673 36.5984C-0.522435 28.3925 -0.522435 20.3521 1.5673 12.1463C2.62086 8.04532 8.92481 4.43285 14.8872 4.15709C142.477 -1.3857 270.397 -1.3857 397.987 4.15709C403.949 4.42891 410.253 8.04532 411.307 12.1463C413.397 20.3521 413.397 28.3925 411.307 36.5984C410.253 40.6993 403.949 44.3118 397.987 44.5876Z" fill="#3498D4"/>
                        </svg>
                        <span>Conheça as Vivências Socioemocionais</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="17" viewBox="0 0 25 17" fill="none" className="arrow">
                            <path d="M15.2134 15.9338C14.731 15.4515 14.731 14.6722 15.2134 14.1899L20 9.37848H1.23686C0.556585 9.37848 -1.90735e-06 8.8219 -1.90735e-06 8.14162C-1.90735e-06 7.46135 0.556585 6.90477 1.23686 6.90477H20L15.201 2.10575C14.7186 1.62338 14.7186 0.844156 15.201 0.361781C15.6834 -0.120594 16.4626 -0.120594 16.945 0.361781L23.8714 7.27582C24.3537 7.7582 24.3537 8.53742 23.8714 9.01979L16.9573 15.9338C16.475 16.4038 15.6834 16.4038 15.2134 15.9338Z" fill="white"/>
                        </svg>
                    </a>
                </div>
                <img src={ovImg8} alt="" className="ov ov8" />
                <img src={ovImg9} alt="" className="ov ov9" />
                <img src={ovImg10} alt="" className="ov ov10" />
                <img src={ovImg11} alt="" className="ov ov11" />
                <img src={ovImg12} alt="" className="ov ov12" />
                <img src={ovImg13} alt="" className="ov ov13" />
            </div>

            <div className="schools large-wrapper">
                <div className="header">
                    <b>Programa HUG – Educação Socioemocional para Escolas</b>
                    <span>Materiais pedagógicos desenvolvidos para cada etapa da educação, promovendo o desenvolvimento contínuo de <br />competências socioemocionais ao longo da vida escolar.</span>
                </div>
                <div className="cards-wrapper">
                    <img src={studens01Img} alt="" className="card-element" />
                    <img src={studens02Img} alt="" className="card-element" />
                    <img src={studens03Img} alt="" className="card-element" />
                    <img src={studens04Img} alt="" className="card-element" />
                </div>
                
                <a href="#">
                    <svg width="360" viewBox="0 0 410 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                        <path d="M394.963 50.8622C268.343 57.185 141.395 57.185 14.7741 50.8622C8.85701 50.5521 2.60095 46.4268 1.5554 41.7487C-0.518466 32.3881 -0.518466 23.2162 1.5554 13.8556C2.60095 9.1775 8.85701 5.05667 14.7741 4.7421C141.395 -1.5807 268.343 -1.5807 394.963 4.7421C400.88 5.05218 407.137 9.1775 408.182 13.8556C410.256 23.2162 410.256 32.3881 408.182 41.7487C407.137 46.4268 400.88 50.5476 394.963 50.8622Z" fill="#90C23D"/>
                    </svg>

                    <span>Conheça as coleções pedagógicas</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="17" viewBox="0 0 25 17" fill="none" className="arrow">
                        <path d="M15.2134 15.9338C14.731 15.4515 14.731 14.6722 15.2134 14.1899L20 9.37848H1.23686C0.556585 9.37848 -1.90735e-06 8.8219 -1.90735e-06 8.14162C-1.90735e-06 7.46135 0.556585 6.90477 1.23686 6.90477H20L15.201 2.10575C14.7186 1.62338 14.7186 0.844156 15.201 0.361781C15.6834 -0.120594 16.4626 -0.120594 16.945 0.361781L23.8714 7.27582C24.3537 7.7582 24.3537 8.53742 23.8714 9.01979L16.9573 15.9338C16.475 16.4038 15.6834 16.4038 15.2134 15.9338Z" fill="white"/>
                    </svg>
                </a>

                <img src={ovImg14} alt="" className="ov ov14" />
                <img src={ovLine2} alt="" className="ov line-star" />
                <img src={ovLine3} alt="" className="ov line-top-2" />
                <img src={ovImg15} alt="" className="ov ov15" />
                <img src={ovImg16} alt="" className="ov ov16" />
            </div>

            <div className="nossos-programas">
                <div className="header">
                    <b>Espaço HUG</b>
                    <span>Conteúdos, reflexões e produções da HUG sobre Educação Socioemocional, <br />cultura de paz, desenvolvimento humano e práticas educacionais contemporâneas.</span>
                </div>
                

                <div className="programas-grid">
                    <a href="#" className="post post1">
                        <div className="title-wrapper">
                            <b className="title">Regulação emocional: O segredo para um final de Ano mais leve</b>
                            <span>23 de dezembro de 2025</span>
                        </div>
                    </a>
                    <a href="#" className="post post2">
                        <div className="title-wrapper">
                            <b className="title">Cuidando das emoções em família</b>
                            <span>3 de dezembro de 2025</span>
                        </div>
                    </a>
                    <a href="#" className="post post3">
                        <div className="title-wrapper">
                            <b className="title">Por uma literatura e uma educação socioemocional para além do 20 de novembro</b>
                            <span>19 de novembro de 2025</span>
                        </div>
                    </a>
                </div>

                <img src={ovImg17} alt="" className="ov ov17" />
                <img src={ovImg18} alt="" className="ov ov18" />
                <img src={ovImg19} alt="" className="ov ov19" />

            </div>

            <div className="bottom-links">
                <a href="#" className="espaco-hug">
                    <svg width="295" height="56" viewBox="0 0 295 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                    <path d="M284.104 50.8622C193.023 57.185 101.708 57.185 10.6273 50.8622C6.37099 50.5521 1.8709 46.4268 1.11882 41.7487C-0.372941 32.3881 -0.372941 23.2162 1.11882 13.8556C1.8709 9.1775 6.37099 5.05667 10.6273 4.7421C101.708 -1.5807 193.023 -1.5807 284.104 4.7421C288.36 5.05218 292.86 9.1775 293.612 13.8556C295.104 23.2162 295.104 32.3881 293.612 41.7487C292.86 46.4268 288.36 50.5476 284.104 50.8622Z" fill="#3498D4"/>
                    </svg>
                    <span>Acesse o Espaço HUG</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="17" viewBox="0 0 25 17" fill="none" className="arrow">
                        <path d="M15.2134 15.9338C14.731 15.4515 14.731 14.6722 15.2134 14.1899L20 9.37848H1.23686C0.556585 9.37848 -1.90735e-06 8.8219 -1.90735e-06 8.14162C-1.90735e-06 7.46135 0.556585 6.90477 1.23686 6.90477H20L15.201 2.10575C14.7186 1.62338 14.7186 0.844156 15.201 0.361781C15.6834 -0.120594 16.4626 -0.120594 16.945 0.361781L23.8714 7.27582C24.3537 7.7582 24.3537 8.53742 23.8714 9.01979L16.9573 15.9338C16.475 16.4038 15.6834 16.4038 15.2134 15.9338Z" fill="white"/>
                    </svg>
                </a>
                <a href="#" className="all-content">
                    <svg width="306" height="56" viewBox="0 0 306 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                    <path d="M294.778 50.8622C200.275 57.185 105.529 57.185 11.0265 50.8622C6.61035 50.5521 1.9412 46.4268 1.16086 41.7487C-0.386953 32.3881 -0.386953 23.2162 1.16086 13.8556C1.9412 9.1775 6.61035 5.05667 11.0265 4.7421C105.529 -1.5807 200.275 -1.5807 294.778 4.7421C299.194 5.05218 303.863 9.1775 304.643 13.8556C306.191 23.2162 306.191 32.3881 304.643 41.7487C303.863 46.4268 299.194 50.5476 294.778 50.8622Z" fill="#FF6C02"/>
                    </svg>

                    <span>Ver todos os conteúdos</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="17" viewBox="0 0 25 17" fill="none" className="arrow">
                        <path d="M15.2134 15.9338C14.731 15.4515 14.731 14.6722 15.2134 14.1899L20 9.37848H1.23686C0.556585 9.37848 -1.90735e-06 8.8219 -1.90735e-06 8.14162C-1.90735e-06 7.46135 0.556585 6.90477 1.23686 6.90477H20L15.201 2.10575C14.7186 1.62338 14.7186 0.844156 15.201 0.361781C15.6834 -0.120594 16.4626 -0.120594 16.945 0.361781L23.8714 7.27582C24.3537 7.7582 24.3537 8.53742 23.8714 9.01979L16.9573 15.9338C16.475 16.4038 15.6834 16.4038 15.2134 15.9338Z" fill="white"/>
                    </svg>
                </a>
            </div>

        </div>
    )
}

export default Programas